export enum TicketingType {
  'None' = 'None',
  'Integrated' = 'Integrated',
  'Onboard' = 'Onboard',
  'Online' = 'Online',
  'Hybrid' = 'Hybrid',
  'Periodically' = 'Periodically',
}
